/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowRoundTimeForwardIcon16Light } from './ArrowRoundTimeForwardIcon16Light';
import { ArrowRoundTimeForwardIcon16Regular } from './ArrowRoundTimeForwardIcon16Regular';
import { ArrowRoundTimeForwardIcon16Solid } from './ArrowRoundTimeForwardIcon16Solid';
import { ArrowRoundTimeForwardIcon20Light } from './ArrowRoundTimeForwardIcon20Light';
import { ArrowRoundTimeForwardIcon20Regular } from './ArrowRoundTimeForwardIcon20Regular';
import { ArrowRoundTimeForwardIcon20Solid } from './ArrowRoundTimeForwardIcon20Solid';
import { ArrowRoundTimeForwardIcon24Regular } from './ArrowRoundTimeForwardIcon24Regular';
import { ArrowRoundTimeForwardIcon24Solid } from './ArrowRoundTimeForwardIcon24Solid';
import { ArrowRoundTimeForwardIcon32Regular } from './ArrowRoundTimeForwardIcon32Regular';
import { ArrowRoundTimeForwardIcon64Regular } from './ArrowRoundTimeForwardIcon64Regular';
var sizes = {
    16: {
        light: ArrowRoundTimeForwardIcon16Light,
        regular: ArrowRoundTimeForwardIcon16Regular,
        solid: ArrowRoundTimeForwardIcon16Solid,
    },
    20: {
        light: ArrowRoundTimeForwardIcon20Light,
        regular: ArrowRoundTimeForwardIcon20Regular,
        solid: ArrowRoundTimeForwardIcon20Solid,
    },
    24: {
        regular: ArrowRoundTimeForwardIcon24Regular,
        solid: ArrowRoundTimeForwardIcon24Solid,
    },
    32: {
        regular: ArrowRoundTimeForwardIcon32Regular,
    },
    64: {
        regular: ArrowRoundTimeForwardIcon64Regular,
    },
};
export var ArrowRoundTimeForwardIcon = forwardRef('ArrowRoundTimeForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
